<template>
    <div class="text-gray-900 text-center">
        <h1 class="text-3xl font-bold">{{__('Website under construction')}}</h1>
        <p class="text-xl">{{__('Sorry, cleanup is currently underway. Please try again in a few hours.')}}</p>
        <img class="mt-5 mx-auto" alt="Under Construction" src="https://i.imgur.com/yq8Bu2f.png">
    </div>
</template>

<script>
import BreezeGuestLayout from "@/Layouts/Guest"
export default {
    layout: BreezeGuestLayout,
}
</script>
